import {
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useEffect, useState } from "react";
import {
  Show,
  ShowProps,
  useDataProvider,
  useNotify,
  useRecordContext,
} from "react-admin";

interface ISummaryPurchaseInvoice {
  schoolId: number;
  schoolPrefix: string;
  total: number | any;
}

const useStyles = makeStyles({
  tableCell: {
    minWidth: "50px",
  },
});

const SubcontractorPurchaseInvoicePanel = (props: ShowProps) => {
  const [schools, setSchools] = useState<ISchool[]>([]);
  const [summaryPurchaseInvoices, setSummaryPurchaseInvoices] = useState<
    ISummaryPurchaseInvoice[]
  >([]);

  const record = useRecordContext();
  const provider = useDataProvider();
  const notify = useNotify();
  const classes = useStyles();

  const getSchools = () => {
    provider
      .getList("schools", {
        filter: {},
        sort: {
          field: "schoolPrefix",
          order: "ASC",
        },
        pagination: {
          page: 1,
          perPage: 1000,
        },
      })
      .then((response) => {
        setSchools(response.data as ISchool[]);
      })
      .catch((error) => {
        notify(`Error, ${error.message}`, "error");
      });
  };

  useEffect(() => {
    getSchools();
  }, []);

  useEffect(() => {
    if (schools.length > 0 && record && record.items) {
      const reinitializeSubcontractorPurchaseInvoices = schools.map(
        (school) => {
          const invoiceItem = record.items.find(
            (item: any) => item.schoolId === school.id
          );

          return {
            schoolId: school.id,
            schoolPrefix: school.schoolPrefix,
            total: invoiceItem ? invoiceItem.total : 0,
          };
        }
      );

      setSummaryPurchaseInvoices(reinitializeSubcontractorPurchaseInvoices);
    }
  }, [schools, record]);

  return (
    <Show
      {...props}
      /* disable the app title change when shown */
      title=" "
      hasEdit={false}
    >
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Purchase Invoice Detail</Typography>
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  {summaryPurchaseInvoices.map((summaryPurchaseInvoice) => (
                    <TableCell
                      key={summaryPurchaseInvoice.schoolId}
                      className={classes.tableCell}
                    >
                      {summaryPurchaseInvoice.schoolPrefix}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  {summaryPurchaseInvoices.map((summaryPurchaseInvoice) => (
                    <TableCell key={summaryPurchaseInvoice.schoolId}>
                      $ {summaryPurchaseInvoice.total.toFixed(2) / 100}
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </SanitizedGrid>
    </Show>
  );
};

export default SubcontractorPurchaseInvoicePanel;
